const MARKETPLACE_TIMEZONES = {
  IN: 'Asia/Kolkata',
  US: 'America/Los_Angeles',
};

const MARKETPLACE_TZ_LABEL = {
  IN: 'IST',
  US: 'PT',
};

function getMarketplaceTimeZone(marketplace) {
  return MARKETPLACE_TIMEZONES[marketplace] || MARKETPLACE_TIMEZONES.IN;
}

function getTimezoneLabel(marketplace) {
  return MARKETPLACE_TZ_LABEL[marketplace] || 'IST';
}

export function formatRelativeOrderAge(value, now = Date.now()) {
  const dateMs = new Date(value).getTime();

  if (!Number.isFinite(dateMs)) {
    return '—';
  }

  const diffMs = Math.max(0, now - dateMs);
  const minutes = Math.floor(diffMs / (60 * 1000));

  if (minutes < 1) {
    return 'Just now';
  }

  if (minutes < 60) {
    return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  }

  const hours = Math.floor(minutes / 60);

  if (hours < 24) {
    return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  }

  const days = Math.floor(hours / 24);

  if (days < 7) {
    return `${days} day${days === 1 ? '' : 's'} ago`;
  }

  const weeks = Math.floor(days / 7);

  if (weeks < 5) {
    return `${weeks} week${weeks === 1 ? '' : 's'} ago`;
  }

  const months = Math.floor(days / 30);

  return `${Math.max(months, 1)} month${months === 1 ? '' : 's'} ago`;
}

export function formatSellerCentralCalendarDate(value, marketplace = 'IN') {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return '—';
  }

  const timeZone = getMarketplaceTimeZone(marketplace);
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  }).formatToParts(date);

  const day = parts.find((part) => part.type === 'day')?.value;
  const month = parts.find((part) => part.type === 'month')?.value;
  const year = parts.find((part) => part.type === 'year')?.value;

  return `${day}/${month}/${year}`;
}

export function formatSellerCentralTime(value, marketplace = 'IN') {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return '—';
  }

  const timeZone = getMarketplaceTimeZone(marketplace);
  const time = new Intl.DateTimeFormat('en-IN', {
    timeZone,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
    .format(date)
    .toLowerCase()
    .replace(/\s/g, ' ')
    .trim();

  return `${time} ${getTimezoneLabel(marketplace)}`;
}

export function SellerCentralOrderDate({ value, marketplace = 'IN', now = Date.now() }) {
  if (!value) {
    return <span className="text-sm text-slate-500">—</span>;
  }

  return (
    <div className="grid gap-0.5 leading-snug">
      <strong className="text-sm font-semibold text-slate-900">
        {formatRelativeOrderAge(value, now)}
      </strong>
      <span className="text-sm text-slate-800">{formatSellerCentralCalendarDate(value, marketplace)}</span>
      <span className="text-sm text-slate-600">{formatSellerCentralTime(value, marketplace)}</span>
    </div>
  );
}
